import { Locale, StaticSiteDto } from '@synergy/models';
import { getLocalizedString } from '@synergy/utils';

import { StaticSite } from '../static-site';

export const mapStaticSite = (locales: Locale[], staticSite: StaticSiteDto): StaticSite => ({
    id: staticSite.id,
    path: staticSite.path,
    text: getLocalizedString(locales, staticSite.text),
    title: getLocalizedString(locales, staticSite.title),
    updatedAt: staticSite.updatedAt && new Date(staticSite.updatedAt),
    createdAt: new Date(staticSite.createdAt),
});
